import { Vue } from '@/utils/vue';

function importAll(components: any) {
  components.keys().forEach((key: string) => {
    const component = components(key).default;
    Vue.component(component.options.name, component);
  });
}

importAll(require.context('./', false, /\.vue$/));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/index.ts